import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './metaVisitaActions';

class MetaVisitaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		
		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='competencia'
								component={Select}
								options={[
									{ id: `${this.props.ano}01`, valor: `Janeiro de ${this.props.ano}` },
									{ id: `${this.props.ano}02`, valor: `Fevereiro de ${this.props.ano}` },
									{ id: `${this.props.ano}03`, valor: `Março de ${this.props.ano}` },
									{ id: `${this.props.ano}04`, valor: `Abril de ${this.props.ano}` },
									{ id: `${this.props.ano}05`, valor: `Maio de ${this.props.ano}` },
									{ id: `${this.props.ano}06`, valor: `Junho de ${this.props.ano}` },
									{ id: `${this.props.ano}07`, valor: `Julho de ${this.props.ano}` },
									{ id: `${this.props.ano}08`, valor: `Agosto de ${this.props.ano}` },
									{ id: `${this.props.ano}09`, valor: `Setembro de ${this.props.ano}` },
									{ id: `${this.props.ano}10`, valor: `Outubro de ${this.props.ano}` },
									{ id: `${this.props.ano}11`, valor: `Novembro de ${this.props.ano}` },
									{ id: `${this.props.ano}12`, valor: `Dezembro de ${this.props.ano}` }
								]}
								label='Competência' placeholder='Informe a competência'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								name='id_grupo_cliente'
								component={Select}
								options={this.props.listaGrupo}
								label='Região'
								cols='12 12 12 12'
								placeholder='Selecione a região'
								readOnly={readOnly} />

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Meta' placeholder='Informe a meta'
								cols='12 6 4 3'
								casas={0}
								readOnly={readOnly} />

						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

MetaVisitaForm = reduxForm({form: 'metaVisitaForm', destroyOnUnmount: false})(MetaVisitaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('metaVisitaForm')(state),
	registro: state.metaVisita.registro,
	listaGrupo: state.metaVisita.listaGrupo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaVisitaForm);
